import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard, { Penalty } from "./scoreboard";
import { clockString, dotPad, upperFirst } from "./util";

export class DeletePenalty extends Handler {
    private side: "home" | "guest";
    private penaltyArray: Penalty[] = [];
    private num = 0;
    private deleteFunction: (index: number) => void = () => {};

    constructor(side: "home" | "guest") {
        super();
        this.side = side;
    }

    boot(): void {
        this.penaltyArray = scoreboard[`${this.side}Penalties`];

        if (this.penaltyArray.length == 0) {
            clock.popHandler();
            return;
        }

        const sideF = upperFirst(this.side) as "Home" | "Guest";
        this.deleteFunction =
            scoreboard[`delete${sideF}Penalty`].bind(scoreboard);

        display.line1(`${this.side.toUpperCase()} DEL PEN?`);
        this.num = 0;

        this.showCurrent();
    }

    showCurrent(): void {
        const penaltyInfo = this.penaltyArray[this.num];
        display.line2(
            `${this.num + 1} P${dotPad(
                penaltyInfo.playerNumber,
                2
            )}  PN ${clockString(penaltyInfo.time, { leftTrim: "•" })}`
        );
    }

    onUp(): void {
        this.num = (this.num + 1) % this.penaltyArray.length;
        this.showCurrent();
    }

    onDown(): void {
        this.num =
            (this.num - 1 + this.penaltyArray.length) %
            this.penaltyArray.length;
        this.showCurrent();
    }

    onEnter(): void {
        this.deleteFunction(this.num);
        clock.popHandler();
    }

    onClear(): void {
        clock.popHandler();
    }
}
